import { render, staticRenderFns } from "./TenantReadinessDialog.vue?vue&type=template&id=1036d69e&"
import script from "./TenantReadinessDialog.vue?vue&type=script&lang=js&"
export * from "./TenantReadinessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports